<template>
  <input
    :value="value"
    class="input-alo mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
    :class="{ 'with-errors': error, 'with-warning': warning }"
    @input="$emit('input', $event.target.value)"
    @blur="onBlur"
    @change="onChange"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: Object,
      default: null,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    documentType: {
      type: String,
      default: '',
    },
    setError: {
      type: Function,
      default() {
        return null
      },
    },
    change: {
      type: Function,
      default() {
        return null
      },
    },
  },
  methods: {
    onChange(e) {
      this.$emit('change', e.target.value)
    },
    onBlur() {
      if ('billing_address_email_address' !== this.name) {
        var splitStr = this.value.toLowerCase().split(' ')
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
        this.$emit('input', splitStr.join(' '))
      }

      // Validate document number
      if ('billing_address_document_number' == this.name) {
        const document_number = this.value.toUpperCase()
        let cleanNumber = document_number.replace(/[^0-9A-Z]/g, '')
        // DNI
        if ('nif' == this.documentType) {
          const validNIF = /^([0-9]{8})([A-Z])$/
          const validSpecialNIF = /^([KLM][0-9]{7})([A-Z])$/
          const validCIF = /^([ABCDEFGHJNPQRSUVW][0-9]{7})([A-Z0-9])$/
          const validNIE = /^([XYZ][0-9]{7})([A-Z])$/

          const validate =
            validNIF.test(cleanNumber) ||
            validSpecialNIF.test(cleanNumber) ||
            validCIF.test(cleanNumber) ||
            validNIE.test(cleanNumber)

          if (!validate) {
            this.$emit('setError', 'El número del documento debe ser un DNI válido.')
          } else {
            this.$emit('setError', '')
          }
        }

        // NIE
        // if ('nie' == this.documentType) {
        //   const validNIE = /^([XYZ][0-9]{7})([A-Z])$/
        //   if (!validNIE.test(cleanNumber)) {
        //     this.$emit('setError', 'El número del documento debe ser un NIE válido.')
        //   } else {
        //     this.$emit('setError', '')
        //   }
        // }

        // OTHERS
        if ('nif' != this.documentType) {
          const validDocument = /^(?=.*[0-9][A-Z])|(\d{6,20})$|(?=.*[A-Z][0-9])[A-Z0-9]{6,20}$/
          if (!validDocument.test(cleanNumber)) {
            this.$emit('setError', 'El número del documento debe ser válido.')
          } else {
            this.$emit('setError', '')
          }
        }

        this.$emit('input', cleanNumber)
      }

      // Validate legal age
      if ('birth_date' == this.name) {
        var today = new Date()
        var currentYear = today.getFullYear()
        var birthDate = this.convertStringToDate(this.value)
        if (1900 > birthDate.getFullYear() || currentYear < birthDate.getFullYear() || 10 > this.value.length) {
          this.$emit('setError', 'La fecha de nacimiento no es válida.')
          return
        }

        var age = currentYear - birthDate.getFullYear()
        var month = today.getMonth() - birthDate.getMonth()

        if (0 > month || (0 === month && today.getDate() < birthDate.getDate())) {
          age--
        }

        if (18 > age) {
          this.$emit('setError', 'Debes ser mayor de edad.')
        } else {
          this.$emit('setError', '')
        }
      }

      // Validate email
      if ('billing_address_email_address' == this.name) {
        const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/
        this.$emit('input', this.value.toLowerCase())

        if (!validEmail.test(this.value)) {
          this.$emit('setError', 'El campo e-mail no es válido')
        } else {
          this.$emit('setError', '')
        }
      }
    },
    convertStringToDate(dateStr) {
      const parts = dateStr.split('/')
      const date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parts[0])
      date.setFullYear(parseInt(parts[2], 10))
      return date
    },
  },
}
</script>
